import { Drawer } from '@src/common/components/Drawer';
import { useCurrentOrderMode } from '@src/orders/hooks/useCurrentOrderMode';
import { OrderDrawerContent } from '@src/orders/OrderDrawerContent';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

interface Props {
  onClose: () => void;
  permit?: { id: string; orderId: string };
}

export const PermitOrderDrawer = ({ onClose, permit }: Props) => {
  const { mode } = useCurrentOrderMode();
  const { data: order } = useQuery({
    queryKey: ['order.listing', permit?.orderId],
    queryFn: async () => await OrdersClient.findOrderListing(permit!.orderId),
    enabled: !!permit?.orderId,
  });

  const queryClient = useQueryClient();
  const refreshOrders = useCallback(() => {
    void queryClient.resetQueries({ queryKey: ['order.listing'] });
  }, [queryClient]);

  return (
    <Drawer open={!!order} onClose={onClose}>
      {order && (
        <OrderDrawerContent
          currentOrder={order}
          mode={mode}
          onDeleteSuccess={onClose}
          onOrderChange={refreshOrders}
          onPermitChange={refreshOrders}
          highlightedPermit={permit?.id}
        />
      )}
    </Drawer>
  );
};
